import { Clock, Users, Building } from 'lucide-react';

const stats = [
  {
    id: 'hours',
    icon: Clock,
    value: '48h',
    label: 'Tempo di attivazione',
    description: 'Dalla richiesta alla presentazione dei profili'
  },
  {
    id: 'profiles',
    icon: Users,
    value: '100+',
    label: 'Profili disponibili',
    description: 'Figure tecniche e manageriali certificate'
  },
  {
    id: 'companies',
    icon: Building,
    value: '30+',
    label: 'Aziende nel network',
    description: 'Imprese specializzate e certificate'
  }
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-[#E94560] mb-4 block">Perché Sell&Rec</span>
          <h2 data-testid="stats-title" className="text-3xl md:text-5xl font-bold text-[#1A1A2E]">
            I numeri che contano
          </h2>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat) => (
            <div 
              key={stat.id}
              data-testid={`stat-card-${stat.id}`}
              className="text-center p-10 border-2 border-gray-100 hover:border-[#1A1A2E] transition-colors"
            >
              <stat.icon className="w-12 h-12 mx-auto mb-6 text-[#1A1A2E]" strokeWidth={1.5} />
              <div className="stat-value mb-2">{stat.value}</div>
              <h3 className="text-lg font-bold text-[#1A1A2E] mb-2">{stat.label}</h3>
              <p className="text-[#888888]">{stat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
